import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const fields = {
  _id: '',
  statusCode: '',
  description: '',
  taxesPaid: '',
  alertOnPayment: '',
  rollToNextYear: '',
  adminOnly: '',
  errorOnMtgCoPayment: '',
  highlightColor: '',
  highlightTaxRecord: '',
  alertOnTaxRecord: '',
  excludeFromPTW: '',
};

export const taxStatusCodesShared = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
    taxStatusCodes: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setTaxStatusCodes(state, list) {
      state.taxStatusCodes = list;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTaxStatusCodesSharedRecords({ commit, dispatch }, {
      baseCrudKey, criteria, postProcessTrans, isItSetState = false,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxStatusCodes($criteria: taxStatusCodesCriteriaType) {
            taxStatusCodes(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxStatusCodes } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxStatusCodes) : taxStatusCodes;
          if (isItSetState) commit('setTaxStatusCodes', processedTransData);
          else commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
    },
    async upserttaxStatusCodes({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upserttaxStatusCodes($item: taxStatusCodesInputType!)  {
            upserttaxStatusCodes(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxUnit = results.data.upserttaxStatusCodes;
        const newList = mergeByIdNewAtTop(taxData || [], newTaxUnit);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the status codes List', { root: true });
      }
    },
    async deleteTaxStatusCode({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletetaxStatusCodeType ($id: ID!)  {
            deletetaxStatusCodeType(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deletetaxStatusCodeType._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the status Code', { root: true });
      }
    },
  },
};

export default taxStatusCodesShared;
